import ImageUploadField from '../common/ImageUploadField';
import { appendFormValue, appendFiles } from '../../utils/formData';

export default function CategoryForm({ form, onChange }) {
  const set = (field, value) => onChange({ ...form, [field]: value });

  return (
    <div className="form-grid">
      <div className="form-group full">
        <label>Name *</label>
        <input
          className="input"
          value={form.name || ''}
          onChange={(e) => set('name', e.target.value)}
          required
        />
      </div>
      <div className="form-group full">
        <label>Slug</label>
        <input
          className="input"
          value={form.slug || ''}
          onChange={(e) => set('slug', e.target.value)}
          placeholder="Auto-generated if empty"
        />
      </div>
      <div className="form-group full">
        <label>Description</label>
        <textarea
          className="input textarea"
          rows={3}
          value={form.description || ''}
          onChange={(e) => set('description', e.target.value)}
        />
      </div>

      <ImageUploadField
        label="Category Image"
        existingUrls={form.existingImage ? [form.existingImage] : []}
        onExistingChange={(urls) => set('existingImage', urls[0] || '')}
        files={form.newImageFiles || []}
        onFilesChange={(files) => set('newImageFiles', files)}
      />
    </div>
  );
}

export const emptyCategoryForm = {
  name: '',
  slug: '',
  description: '',
  existingImage: '',
  newImageFiles: [],
};

export function categoryToForm(category) {
  if (!category) return { ...emptyCategoryForm };
  return {
    name: category.name || '',
    slug: category.slug || '',
    description: category.description || '',
    existingImage: category.image || '',
    newImageFiles: [],
  };
}

export function formToCategoryFormData(form) {
  const formData = new FormData();

  appendFormValue(formData, 'name', form.name);
  appendFormValue(formData, 'slug', form.slug);
  appendFormValue(formData, 'description', form.description);
  appendFormValue(formData, 'existingImage', form.existingImage || '');
  appendFiles(formData, 'image', form.newImageFiles || []);

  return formData;
}
